var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerticalDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2913 15.8333C12.2913 17.1 11.2663 18.125 9.99967 18.125C8.73301 18.125 7.70801 17.1 7.70801 15.8333C7.70801 14.5667 8.73301 13.5417 9.99967 13.5417C11.2663 13.5417 12.2913 14.5667 12.2913 15.8333ZM8.95801 15.8333C8.95801 16.4083 9.42467 16.875 9.99967 16.875C10.5747 16.875 11.0413 16.4083 11.0413 15.8333C11.0413 15.2583 10.5747 14.7917 9.99967 14.7917C9.42467 14.7917 8.95801 15.2583 8.95801 15.8333Z",
    fill: "#6D6D6D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2913 4.16659C12.2913 5.43325 11.2663 6.45825 9.99967 6.45825C8.73301 6.45825 7.70801 5.43325 7.70801 4.16659C7.70801 2.89992 8.73301 1.87492 9.99967 1.87492C11.2663 1.87492 12.2913 2.89992 12.2913 4.16659ZM8.95801 4.16659C8.95801 4.74159 9.42467 5.20825 9.99967 5.20825C10.5747 5.20825 11.0413 4.74159 11.0413 4.16659C11.0413 3.59159 10.5747 3.12492 9.99967 3.12492C9.42467 3.12492 8.95801 3.59159 8.95801 4.16659Z",
    fill: "#6D6D6D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2913 10.0001C12.2913 11.2667 11.2663 12.2917 9.99967 12.2917C8.73301 12.2917 7.70801 11.2667 7.70801 10.0001C7.70801 8.73341 8.73301 7.70841 9.99967 7.70841C11.2663 7.70841 12.2913 8.73341 12.2913 10.0001ZM8.95801 10.0001C8.95801 10.5751 9.42467 11.0417 9.99967 11.0417C10.5747 11.0417 11.0413 10.5751 11.0413 10.0001C11.0413 9.42508 10.5747 8.95841 9.99967 8.95841C9.42467 8.95841 8.95801 9.42508 8.95801 10.0001Z",
    fill: "#6D6D6D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerticalDots);
export default __webpack_public_path__ + "static/media/vertical-dots.fb087e5186559cc4441399db50840ea6.svg";
export { ForwardRef as ReactComponent };